import React from 'react'
import PropTypes from 'prop-types'

import api from 'services/pet-notify-api'

import InvitationAcceptedScreen from 'ContactApp/screens/Invitation/Accepted'

class InvitationAcceptedScreenContainer extends React.PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        token: PropTypes.string,
      }),
    }),
  }

  state = {
    isLoading: true,
    error: '',
  }

  async componentDidMount() {
    const { match } = this.props
    const { params } = match
    const { token } = params

    try {
      const { user, contact } = await api.contactInvitations.view(token)
      this.setState({ isLoading: false, user, contact })
    } catch (error) {
      this.setState({ isLoading: false, error })
    }
  }

  generateProps = () => ({
    ...this.props,
    ...this.state,
  })

  render() {
    const props = this.generateProps()

    return <InvitationAcceptedScreen {...props} />
  }
}

export default InvitationAcceptedScreenContainer
